import { render, staticRenderFns } from "./ViqActionChips.vue?vue&type=template&id=7e9682bf&scoped=true"
import script from "./ViqActionChips.vue?vue&type=script&lang=js"
export * from "./ViqActionChips.vue?vue&type=script&lang=js"
import style0 from "./ViqActionChips.vue?vue&type=style&index=0&id=7e9682bf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9682bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e9682bf')) {
      api.createRecord('7e9682bf', component.options)
    } else {
      api.reload('7e9682bf', component.options)
    }
    module.hot.accept("./ViqActionChips.vue?vue&type=template&id=7e9682bf&scoped=true", function () {
      api.rerender('7e9682bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqActionChips.vue"
export default component.exports